import React, { useState, useEffect } from 'react';
import { Add_company, List_company, List_industry, List_country } from '../../Utils/Api';
import { toast } from 'react-toastify';

const Companies = () => {
  const [companies, setCompanies] = useState([]);
  const [countries, setCountries] = useState([]);
  const [industries, setIndustries] = useState([]);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    address: '',
    countryId: '',
    website: '',
    status: '1',
    logo: null,
    industry: ''
  });
  const [editingId, setEditingId] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [logoPreview, setLogoPreview] = useState(null);
  const REACT_APP_API_URL = `https://skillagig.qcodesinfotech.com/uploads//`;

  // Fetch data on component mount
  useEffect(() => {
    fetchCompanies();
    fetchCountries();
    fetchIndustries();
  }, []);

  // Fetch all companies
  const fetchCompanies = async () => {
    setLoading(true);
    try {
      const response = await List_company();
      if (response && response.data.data) {
        setCompanies(response.data.data);
      }
    } catch (error) {
      console.error('Error fetching companies:', error);
      toast.error('Failed to fetch companies');
    } finally {
      setLoading(false);
    }
  };

  // Fetch countries for dropdown
  const fetchCountries = async () => {
    try {
      const response = await List_country();
      if (response && response.data?.data) {
        setCountries(response.data.data);
      }
    } catch (error) {
      console.error('Error fetching countries:', error);
    }
  };

  // Fetch industries for dropdown
  const fetchIndustries = async () => {
    try {
      const response = await List_industry();
      if (response && response.data?.data) {
        setIndustries(response.data.data);
      }
    } catch (error) {
      console.error('Error fetching industries:', error);
    }
  };

  // Handle form input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  // Handle file input change
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData(prev => ({ ...prev, logo: file }));
      // Create preview
      const reader = new FileReader();
      reader.onloadend = () => {
        setLogoPreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  // Handle form submission (Add/Update)
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validation
    if (!formData.name.trim()) {
      toast.error('Please enter company name');
      return;
    }
    if (!formData.email.trim()) {
      toast.error('Please enter email');
      return;
    }
    if (!formData.countryId) {
      toast.error('Please select a country');
      return;
    }

    setLoading(true);
    try {
      // Create FormData object
      const submitData = new FormData();
      submitData.append('name', formData.name);
      submitData.append('email', formData.email);
      submitData.append('phone', formData.phone);
      submitData.append('address', formData.address);
      submitData.append('countryId', formData.countryId);
      submitData.append('website', formData.website);
      submitData.append('status', formData.status);
      submitData.append('industry', formData.industry);

      if (formData.logo) {
        submitData.append('logo', formData.logo);
      }

      if (editingId) {
        // Update existing company
        // await Update_company(editingId, submitData);
        toast.success('Company updated successfully');
      } else {
        // Add new company
        await Add_company(submitData);
        toast.success('Company added successfully');
      }

      // Reset form and refresh list
      resetForm();
      setShowModal(false);
      fetchCompanies();
    } catch (error) {
      console.error('Error saving company:', error);
      toast.error('Failed to save company');
    } finally {
      setLoading(false);
    }
  };

  // Reset form
  const resetForm = () => {
    setFormData({
      name: '',
      email: '',
      phone: '',
      address: '',
      countryId: '',
      website: '',
      status: '1',
      logo: null,
      industry: ''
    });
    setLogoPreview(null);
    setEditingId(null);
  };

  // Handle edit
  const handleEdit = (company) => {
    setFormData({
      name: company.name || '',
      email: company.email || '',
      phone: company.phone || '',
      address: company.address || '',
      countryId: company.countryId?._id || company.countryId || '',
      website: company.url || company.website || '',
      status: company.status?.toString() || '1',
      logo: null,
      industry: company.industry?._id || company.industry || ''
    });
    setEditingId(company._id || company.id);
    setLogoPreview(company.logo ? `https://skillagig.qcodesinfotech.com/${company.logo}` : null);
    setShowModal(true);
  };
  //   "uploads/logo-1759932403550.png"


  // Handle delete
  const handleDelete = async () => {
    if (!deleteId) return;

    setLoading(true);
    try {
      //   await Delete_company(deleteId);
      toast.success('Company deleted successfully');
      setDeleteId(null);
      fetchCompanies();
    } catch (error) {
      console.error('Error deleting company:', error);
      toast.error('Failed to delete company');
    } finally {
      setLoading(false);
    }
  };

  // Open add modal
  const handleAdd = () => {
    resetForm();
    setShowModal(true);
  };

  return (
    <div className="main-content">
      <div className="row my-4 mx-1">
        <div className="d-md-flex d-block align-items-center justify-content-between my-4 page-header-breadcrumb">
          <h1 className="page-title fw-semibold fs-18 mb-0 mt-2">Companies</h1>
          <div className="ms-md-1 ms-0 ">
            <nav>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item"><a href="#">Management</a></li>
                <li className="breadcrumb-item active" aria-current="page">Companies</li>
              </ol>
            </nav>
          </div>
        </div>

        {/* Main Content Card */}
        <div className="card custom-card">
          <div className="card-header d-flex justify-content-between align-items-center">
            <h6 className="card-title mb-0">Companies List</h6>
            <button
              className="btn btn-primary btn-sm"
              onClick={handleAdd}
            >
              <i className="ri-add-line me-1"></i> Add Company
            </button>
          </div>
          <div className="card-body">
            <div className="table-responsive">
              <table className="table text-nowrap">
                <thead className="table-primary">
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col">Logo</th>
                    <th scope="col">Company Name</th>
                    <th scope="col">Email</th>
                    <th scope="col">Phone</th>
                    <th scope="col">Country</th>
                    <th scope="col">Status</th>
                    <th scope="col">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {loading && (
                    <tr>
                      <td colSpan="8" className="text-center py-4">
                        <div className="spinner-border text-primary" role="status">
                          <span className="visually-hidden">Loading...</span>
                        </div>
                      </td>
                    </tr>
                  )}

                  {!loading && companies.length === 0 && (
                    <tr>
                      <td colSpan="8" className="text-center py-4">
                        No companies found
                      </td>
                    </tr>
                  )}

                  {!loading && companies.map((company, index) => (
                    <tr key={company._id || company.id}>
                      <th scope="row">{index + 1}</th>
                      <td>
                        {company.logo ? (
                          <img
                            // src={`${process.env.REACT_APP_API_URL}/${company.logo}`} 
                            src={`https://skillagig.qcodesinfotech.com/${company.logo}`}
                            alt={company.name}
                            style={{ width: '40px', height: '40px', objectFit: 'cover', borderRadius: '4px' }}
                          />
                        ) : (
                          <div className="bg-light d-flex align-items-center justify-content-center"
                            style={{ width: '40px', height: '40px', borderRadius: '4px' }}>
                            <i className="ri-building-line text-muted"></i>
                          </div>
                        )}
                      </td>
                      <td>{company.name}</td>
                      <td>{company.email}</td>
                      <td>{company.phone || 'N/A'}</td>
                      <td>{company.countryId?.name || 'N/A'}</td>
                      <td>
                        <span className={`badge ${company.status === 1 ? 'bg-success-transparent' : 'bg-danger-transparent'}`}>
                          {company.status === 1 ? 'Active' : 'Inactive'}
                        </span>
                      </td>
                      <td>
                        <div className="hstack gap-2 fs-15">
                          <button
                            onClick={() => handleEdit(company)}
                            className="btn btn-icon btn-sm btn-info-transparent rounded-pill"
                            title="Edit"
                          >
                            <i className="ri-edit-line"></i>
                          </button>
                          <button
                            onClick={() => setDeleteId(company._id || company.id)}
                            className="btn btn-icon btn-sm btn-danger-transparent rounded-pill"
                            data-bs-toggle="modal"
                            data-bs-target="#deleteModal"
                            title="Delete"
                          >
                            <i className="ri-delete-bin-line"></i>
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        {/* Add/Edit Modal */}
        {showModal && (
          <div className="modal fade show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
            <div className="modal-dialog modal-dialog-centered modal-lg">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">
                    {editingId ? 'Edit Company' : 'Add New Company'}
                  </h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setShowModal(false)}
                  ></button>
                </div>
                <form onSubmit={handleSubmit}>
                  <div className="modal-body">
                    <div className="row">
                      {/* Company Name */}
                      <div className="col-md-6 mb-3">
                        <label htmlFor="name" className="form-label">Company Name <span className="text-danger">*</span></label>
                        <input
                          type="text"
                          className="form-control"
                          id="name"
                          name="name"
                          value={formData.name}
                          onChange={handleInputChange}
                          placeholder="Enter company name"
                          required
                        />
                      </div>

                      {/* Email */}
                      <div className="col-md-6 mb-3">
                        <label htmlFor="email" className="form-label">Email <span className="text-danger">*</span></label>
                        <input
                          type="email"
                          className="form-control"
                          id="email"
                          name="email"
                          value={formData.email}
                          onChange={handleInputChange}
                          placeholder="contact@company.com"
                          required
                        />
                      </div>

                      {/* Phone */}
                      <div className="col-md-6 mb-3">
                        <label htmlFor="phone" className="form-label">Phone</label>
                        <input
                          type="tel"
                          className="form-control"
                          id="phone"
                          name="phone"
                          value={formData.phone}
                          onChange={handleInputChange}
                          placeholder="+1-234-567-8901"
                        />
                      </div>

                      {/* Country */}
                      <div className="col-md-6 mb-3">
                        <label htmlFor="countryId" className="form-label">Country <span className="text-danger">*</span></label>
                        <select
                          className="form-select"
                          id="countryId"
                          name="countryId"
                          value={formData.countryId}
                          onChange={handleInputChange}
                          required
                        >
                          <option value="">Select a country</option>
                          {countries.map(country => (
                            <option key={country._id} value={country._id}>
                              {country.name}
                            </option>
                          ))}
                        </select>
                      </div>

                      {/* Industry */}
                      <div className="col-md-6 mb-3">
                        <label htmlFor="industry" className="form-label">Industry</label>
                        <select
                          className="form-select"
                          id="industry"
                          name="industry"
                          value={formData.industry}
                          onChange={handleInputChange}
                        >
                          <option value="">Select an industry</option>
                          {industries.map(industry => (
                            <option key={industry._id} value={industry._id}>
                              {industry.title}
                            </option>
                          ))}
                        </select>
                      </div>

                      {/* Website */}
                      <div className="col-md-6 mb-3">
                        <label htmlFor="website" className="form-label">Website</label>
                        <input
                          type="url"
                          className="form-control"
                          id="website"
                          name="website"
                          value={formData.website}
                          onChange={handleInputChange}
                          placeholder="https://company.com"
                        />
                      </div>

                      {/* Address */}
                      <div className="col-12 mb-3">
                        <label htmlFor="address" className="form-label">Address</label>
                        <textarea
                          className="form-control"
                          id="address"
                          name="address"
                          value={formData.address}
                          onChange={handleInputChange}
                          rows="2"
                          placeholder="Enter company address"
                        ></textarea>
                      </div>

                      {/* Logo Upload */}
                      <div className="col-md-6 mb-3">
                        <label htmlFor="logo" className="form-label">Company Logo</label>
                        <input
                          type="file"
                          className="form-control"
                          id="logo"
                          name="logo"
                          onChange={handleFileChange}
                          accept="image/*"
                        />
                        {logoPreview && (
                          <div className="mt-2">
                            <img
                              src={logoPreview}
                              alt="Logo preview"
                              style={{ width: '100px', height: '100px', objectFit: 'cover', borderRadius: '8px' }}
                            />
                          </div>
                        )}
                      </div>

                      {/* Status */}
                      <div className="col-md-6 mb-3">
                        <label htmlFor="status" className="form-label">Status</label>
                        <select
                          className="form-select"
                          id="status"
                          name="status"
                          value={formData.status}
                          onChange={handleInputChange}
                        >
                          <option value="1">Active</option>
                          <option value="0">Inactive</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-secondary"
                      onClick={() => setShowModal(false)}
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="btn btn-primary"
                      disabled={loading}
                    >
                      {loading ? (
                        <>
                          <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                          {editingId ? 'Updating...' : 'Adding...'}
                        </>
                      ) : (
                        editingId ? 'Update' : 'Add'
                      )}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        )}

        {/* Delete Confirmation Modal */}
        <div className="modal fade" id="deleteModal" tabIndex="-1">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Confirm Delete</h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  onClick={() => setDeleteId(null)}
                ></button>
              </div>
              <div className="modal-body">
                <p>Are you sure you want to delete this company?</p>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                  onClick={() => setDeleteId(null)}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-danger"
                  data-bs-dismiss="modal"
                  onClick={handleDelete}
                  disabled={loading}
                >
                  {loading ? 'Deleting...' : 'Delete'}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div >
    </div >
  );
};

export default Companies;
